import {
  selectRoleChangeRequest,
  useHMSActions,
  useHMSStore,
} from "@100mslive/react-sdk";

import { ROLES_CONVERT } from "../common/roles";
import React from "react";
import { RequestDialog } from "../primitives/DialogContent";
import { convertRolesName } from "../common/utils";
import { useIsHeadless } from "./AppData/useUISettings";
import { useTranslation } from "react-i18next";

export const RoleChangeRequestModal = () => {
  const hmsActions = useHMSActions();
  const isHeadless = useIsHeadless();
  const roleChangeRequest = useHMSStore(selectRoleChangeRequest);
  const { t } = useTranslation();

  if (!roleChangeRequest?.role || isHeadless) {
    return null;
  }

  return (
    <RequestDialog
      title="Yêu cầu thay đổi vai trò"
      onOpenChange={value =>
        !value && hmsActions.rejectChangeRole(roleChangeRequest)
      }
      body={`${
        roleChangeRequest?.requestedBy?.name
      } đã yêu cầu bạn thay đổi vai trò của mình thành ${
        t("obj_roles." + ROLES_CONVERT[convertRolesName(roleChangeRequest?.role?.name)])
      }.`}
      onAction={() => {
        hmsActions.acceptChangeRole(roleChangeRequest);
      }}
      actionText="Chấp nhận"
      cancelText="Hủy bỏ"
    />
  );
};
